import React, { Component } from 'react';
import { Formik, Field, ErrorMessage, FieldProps } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Message, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { appStateServerRequests } from '../redux/selectors';
import { getServerStateAction, resetPasswordAction } from '../redux/actions';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';
import { ResetPasswordValues } from '../interfaces';
import { TranslationComponent } from '../components/TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

const SignInSchema = (t: typeof i18n.t) =>
  Yup.object().shape({
    email: Yup.string().email(t('Invalid e-mail address')).required(t('Required field')),
    password: Yup.string().required(t('Required field')),
  });

interface ResetPasswordSceneProps extends Component {
  i18n: typeof i18n;
  t: typeof i18n.t;
  resetPasswordAction: typeof resetPasswordAction;
  serverRequest?: ServerRequestStatus;
  token: string;
}

class PResetPasswordScene extends Component<ResetPasswordSceneProps> {
  handleSubmit = (values: ResetPasswordValues) => {
    this.props.resetPasswordAction(values);
  };

  render() {
    const { serverRequest, token, t } = this.props;

    return (
      <Grid textAlign="center" style={{ height: '100vh' }} verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as="h2" textAlign="center">
            <TranslationComponent stringKey={'Reset password'} />
          </Header>
          <Formik
            initialValues={{
              token,
              email: '',
              password: '',
            }}
            validationSchema={SignInSchema(t)}
            onSubmit={this.handleSubmit}
          >
            {({ handleSubmit, isSubmitting }) => (
              <Form
                size="large"
                error
                loading={isSubmitting && serverRequest && serverRequest.pending}
                onSubmit={handleSubmit}
              >
                <Segment stacked>
                  <Field name="email">
                    {({ field }: FieldProps) => (
                      <Form.Input placeholder={t('E-mail address')} fluid icon="user" iconPosition="left" {...field} />
                    )}
                  </Field>
                  <ErrorMessage name="email">{(msg) => <Message error content={msg} />}</ErrorMessage>
                  <Field name="password">
                    {({ field }: FieldProps) => (
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder={t('Password')}
                        type="password"
                        {...field}
                      />
                    )}
                  </Field>
                  <ErrorMessage name="password">{(msg) => <Message error content={msg} />}</ErrorMessage>
                  <Button primary fluid size="large" type="submit">
                    <TranslationComponent stringKey={'Reimposta password'} />
                  </Button>
                  {serverRequest && serverRequest.success && <Message content={t('Password reimpostata')} />}
                  {serverRequest && serverRequest.error && <Message error content={t('Richiesta fallita')} />}
                </Segment>
              </Form>
            )}
          </Formik>
          {serverRequest && serverRequest.success && (
            <Message>
              <Link to="/signin">
                <TranslationComponent stringKey={'Torna al login'} />
              </Link>
            </Message>
          )}
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state: RootState, ownProps: any) => ({
  token: ownProps.match.params.token,
  serverRequest: appStateServerRequests(state, ActionType.RESET_PASSWORD),
});

export const ResetPasswordScene = connect(mapStateToProps, { getServerStateAction, resetPasswordAction })(
  withTranslation()(PResetPasswordScene)
);
